// Public About page (renter-facing).
// Route: /about: wrapped by PublicLayout so header/footer come from there.
//
// Content is centralised in /content/about.jsx so non-technical updates
// don't require touching JSX. Content is bilingual: this page resolves
// the active language via useT() before handing hero/sections to
// MarketingPage.
import MarketingPage from "@/components/MarketingPage";
import CachePublicShell from "@/components/CachePublicShell";
import { useT } from "@/i18n/I18nProvider";
import { ABOUT } from "@/content/about";

export default function About() {
  const { lang } = useT();
  const content = ABOUT[lang] || ABOUT.en;
  return (
    <>
      <CachePublicShell />
      <MarketingPage
        testId="about-page"
        audience="renter"
        seo={{
          title: "About ConfirmPH: Rental Booking Confirmation in the Philippines",
          description:
            "ConfirmPH helps renters and rental businesses check, confirm, " +
            "track and understand rental bookings more clearly across the Philippines.",
          canonical: "/about",
        }}
        hero={content.hero}
        sections={content.sections}
      />
    </>
  );
}
